import { gql } from '@apollo/client'

const mutationCreateVirtualModule = gql(`
  mutation createVirtualModule ( $title: String!, $assetTypes: [String], $isActive: Boolean, $isArchived: Boolean,  $project: String! ) {
    createVirtualModule (title: $title, assetTypes: $assetTypes, isActive: $isActive, isArchived: $isArchived, project: $project) {
      id
      title,
    }
  }`)

export default mutationCreateVirtualModule
